import React, { useState } from 'react';
import { Button, Card, Alert, Spinner, Row, Col } from 'react-bootstrap';
import d_log from 'loglevel';

const SampleApi = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleGoClick = async () => {
    setLoading(true);
    setError(null);
    setData(null);

    try {
      const response = await fetch('https://jsonplaceholder.typicode.com/todos/1');
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const result = await response.json();
      setData(result);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const renderJsonAsKeyValue = (obj) => {
    return Object.entries(obj).map(([key, value]) => (
      <Row key={key} className="mb-2">
        <Col md={3}>
          <strong>{key}:</strong>
        </Col>
        <Col md={9}>
          <code>{typeof value === 'string' ? `"${value}"` : String(value)}</code>
        </Col>
      </Row>
    ));
  };

  return (
    <div>
      <h2>Sample API</h2>
      <p>This will call the JSONPlaceholder API to fetch a todo item.</p>

      <Button
        variant="primary"
        onClick={handleGoClick}
        disabled={loading}
        className="mb-3"
      >
        {loading ? (
          <>
            <Spinner animation="border" size="sm" className="me-2" />
            Loading...
          </>
        ) : (
          'Go'
        )}
      </Button>

      {error && (
        <Alert variant="danger" className="mt-3">
          <strong>Error:</strong> {error}
        </Alert>
      )}

      {data && (
        <Card className="mt-3">
          <Card.Header>
            <h5>API Response</h5>
          </Card.Header>
          <Card.Body>
            <h6>Key-Value Pairs:</h6>
            {renderJsonAsKeyValue(data)}

            <hr className="my-4" />

            <h6>Raw JSON:</h6>
            <pre className="bg-light p-3 rounded">
              {JSON.stringify(data, null, 2)}
            </pre>
          </Card.Body>
        </Card>
      )}
    </div>
  );
};

export default SampleApi;